import React, { useState } from 'react';

import { CONTRACT_TYPE } from '../../constants';
import { TypeContract } from '../../types';

import styles from './MenuDrawerBanner.module.scss';

/**
 * 드로어 상단에 배너를 표시하는 컴포넌트
 * @description 서버에서 배너 표시 여부, 배너 이미지를 받아 표시하도록 작업 예정
 */
const MenuDrawerBanner = ({ contractType, closeDrawer }: { contractType?: TypeContract; closeDrawer: () => void }) => {
  const [bannerConfig] = useState<{
    show: boolean;
    url: string;
  }>({
    show: false,
    url: '',
  });

  const handleBannerClick = () => {
    if (!bannerConfig.url) return;

    const formWindow = window.open(bannerConfig.url);
    if (formWindow) {
      closeDrawer();
    }
  };

  return (
    bannerConfig.show && (
      <div className={styles['drawer-banner-container']}>
        <button
          className={`${styles['banner-image']} ${contractType === CONTRACT_TYPE.CONTRACT ? styles['contract'] : ''}
    ${contractType === CONTRACT_TYPE.SHORT ? styles['short'] : ''}`}
          onClick={handleBannerClick}
        />
      </div>
    )
  );
};

export default MenuDrawerBanner;
